import { Component, Input, OnInit } from '@angular/core';
import { CardLinkOffer, CardLinkOffersQuery, CardLinkOffersService, MemberQuery } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Observable } from 'rxjs';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgbcl-card-linking-featured-offers',
  templateUrl: './card-linking-featured-offers.component.html',
  styleUrls: ['./card-linking-featured-offers.component.scss'],
})
export class CardLinkingFeaturedOffersComponent implements OnInit {
  featuredOffers$: Observable<CardLinkOffer[]>;
  @Input() numberOfOffers: number = 3;
  currentLcid: string;
  screenType = ScreenType;

  customOptions: OwlOptions = {
    loop: true,
    autoHeight: false,
    autoWidth: false,
    margin: OwlCarouselSettings.Margin,
    autoplay: OwlCarouselSettings.Autoplay,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      540: { items: 2 },
      740: { items: 3 },
    },
  };

  constructor(
    private memberQuery: MemberQuery,
    private cardLinkOffersQuery: CardLinkOffersQuery,
    private cardLinkOffersService: CardLinkOffersService
  ) {}

  ngOnInit(): void {
    this.currentLcid = this.memberQuery.getUserContext().lcid;
    this.cardLinkOffersService.fatchAffiliateOffer().toPromise();
    this.featuredOffers$ = this.cardLinkOffersQuery.featuredOffers(this.numberOfOffers);
  }
}
